import useMarketplaceHeaderBi, {
  BI_CLICK_TYPES,
} from '@components/Hooks/useMarketplaceHeaderBi';
import { PAGE_NAMES } from '@utils/partnerProfileUtils';
import { Dismiss, Menu } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/fe-essentials-standalone';
import s from '../AgencyProfileHeader.module.scss';

interface IMobileMenuOpenButtonProps {
  isMobileMenuOpen?: boolean;
  setIsMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileMenuOpenButton = ({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
}: IMobileMenuOpenButtonProps) => {
  const { t } = useTranslation();
  const { reportClick } = useMarketplaceHeaderBi({
    pageName: PAGE_NAMES.PROFILE_PAGE,
  });

  return (
    <li className={`${s.cell} ${s.mobile} ${s.right}`}>
      <button
        aria-label={t('marketplace-header-open-menu-label')}
        data-hook="mobile-menu"
        className={s.mobileButton}
        onClick={() => {
          reportClick({ clickType: BI_CLICK_TYPES.mobileMenu });
          setIsMobileMenuOpen((isOpen) => !isOpen);
        }}
      >
        {isMobileMenuOpen ? <Dismiss /> : <Menu />}
      </button>
    </li>
  );
};

export default MobileMenuOpenButton;
